<template>
  <div style="width:90%">
    <div class="chart1">
      <g-chart
        type="LineChart"
        :data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>

import { GChart } from 'vue-google-charts'

export default {
  name: 'SalesViewChart',
  components: {
    GChart
  },
  data: function () {
    return {
      
    }
  },
  props: [
    'chartData',
    'chartOptions'
    ],
  methods: {

  },
  computed: {
    
  },
  mounted () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:100%;
  height:280px;
}
</style>
